import {
  CaretDownOutlined,
  CaretUpOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  FilterFilled,
} from "@ant-design/icons";
import { Button, Checkbox, Modal, Popover, Table } from "antd";
import React, { useEffect, useMemo, useRef, useState } from "react";
// import { Resizable } from "react-resizable";
// import "react-resizable/css/styles.css"; // Import the styles
import { useDispatch, useSelector } from "react-redux";
import { CONFIG, lang } from "../../constants/common.const";
import { closeOverlay, openOverlay } from "../../redux/overlay";
import { isEmptyData } from "../../utils/helper";
import FilterPopover from "./FilterPopover";
import "./table.scss";
import { setListColumn, setListDataTable } from "../../redux/ledger";

const CommonFilterTable = ({
  columns = [],
  data = [],
  scrollY = 500,
  scrollX = "",
  className = "",
  rowClassName,
  onRow = () => {},
  color = "#ffffff",
  rowKey,
  paging,
  isLeft = true,
  keepFilterSort,
  setFirstNodeFilter = () => {},
  tableKey = "",
  addedLeft = 0,
  disabledFilter,
  idFocus,
}) => {
  const dataFinal = data.map((row) => {
    Object.keys(row).forEach((key) => {
      if (row[key] === undefined || row[key] === null) {
        row[key] = "";
      }
    });
    return row;
  });
  const { show } = useSelector((state) => state.overlay);
  const [columnFilters, setColumnFilters] = useState({});
  const [filteredData, setFilteredData] = useState(data);
  const [previousData,setPreviousData]  = useState(data)
  const [lastColFilter,setLastColFilter] = useState()
  const [visiblePopover, setVisiblePopover] = useState(null);
  const [sort, setSort] = useState({ key: "", mode: "asc" });
  const [selectedChildKeys, setSelectedChildKeys] = useState([]);
  const [visibleModal, setVisibleModal] = useState(false);
  const [columnsWidth, setColumnsWidth] = useState({});
  const [positionLeft, setPositionLeft] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const { widthModalColTable, collapsed } = useSelector(
    (state) => state.sideBar
  );

  const [currentColumnFilter, setCurrentColumnFilter] = useState([]);
  const dispatch = useDispatch();

  const resetFilterColumn = (colKey) => {
    setCurrentColumnFilter(currentColumnFilter.filter((i) => i != colKey));
  };

  const allChildColumns = useMemo(() => {
    return columns.flatMap((col) =>
      col.children
        ? col.children.map((child) => ({
            title: child.title,
            dataIndex: child.dataIndex,
            width: child.width,
          }))
        : [{ title: col.title, dataIndex: col.dataIndex, width: col.width }]
    );
  }, [columns]);

  useEffect(() => {
    if (allChildColumns.length > 0 && selectedChildKeys.length === 0) {
      setSelectedChildKeys(allChildColumns.map((child) => child.dataIndex));
    }

    // Initialize columns width
    const initialWidths = {};
    allChildColumns.forEach((col) => {
      if (col.width) {
        initialWidths[col.dataIndex] = col.width;
      }
    });
    setColumnsWidth(initialWidths);
  }, [allChildColumns]);

  const allKeys = useMemo(
    () => allChildColumns.map((child) => child.dataIndex),
    [allChildColumns]
  );

  const isAllSelected = selectedChildKeys.length === allKeys.length;
  const isIndeterminate =
    selectedChildKeys.length > 0 && selectedChildKeys.length < allKeys.length;

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      setSelectedChildKeys(allKeys);
    } else {
      setSelectedChildKeys([]);
    }
  };

  // const getUniqueColumnValues = (key) => {
  //   return [
  //     ...new Set(data.map((item) => (isEmptyData(item[key]) ? "" : item[key]))),
  //   ]
  //     .sort((a, b) => {
  //       if (a === "") return -1;
  //       if (b === "") return 1;

  //       const aStr = typeof a === "number" ? a.toString() : a;
  //       const bStr = typeof b === "number" ? b.toString() : b;
  //       return aStr.localeCompare(bStr, "ja", { numeric: true });
  //     })
  //     .map((val) => ({
  //       label: val === "" ? " (なし)" : val,
  //       value: val,
  //     }));
  // };

  const getUniqueColumnValues = (key, source = data) => {
    return [
      ...new Set(source.map((item) => (isEmptyData(item[key]) ? "" : item[key]))),
    ]
      .sort((a, b) => {
        if (a === "") return -1;
        if (b === "") return 1;
        return String(a).localeCompare(String(b), "ja", { numeric: true });
      })
      .map((val) => ({
        label: val === "" ? " (なし)" : val,
        value: val,
      }));
  };

  
  const applyFilters = (columnKey, selectedValues, type,isReset) => {
    setCurrentPage(1);
    const updatedFilters = { ...columnFilters, [columnKey]: selectedValues };
    setColumnFilters(updatedFilters);
    const isLastReset = isReset && currentColumnFilter.map(i => i).length === 1
    setLastColFilter(isLastReset ? null : columnKey)
    const currentData = JSON.parse(JSON.stringify(filteredData))

    let result = data;
    for (const [key, values] of Object.entries(updatedFilters)) {
      if (values && Array.isArray(values)) {
        if (!values.length) {
          result = [];
        } else {
          result = result.filter((item) => values.includes(item[key]));
        }
      }
    }

   if(columnKey !== lastColFilter){
    setPreviousData(isLastReset ? result : currentData)
   }

    result = sortData(result);
    setFilteredData(result);

    // set First Node
    if (type !== "sort") {
      if (result && Array.isArray(result) && result.length > 0) {
        if (setFirstNodeFilter) {
          setFirstNodeFilter(result[0]);
        }
      } else {
        if (setFirstNodeFilter) {
          setFirstNodeFilter(undefined);
        }
      }
    }
    setCurrentColumnFilter(
      currentColumnFilter.includes(columnKey)
        ? currentColumnFilter
        : [...currentColumnFilter, columnKey]
    );
  };

  const clearFilter = (columnKey) => {
    const updated = { ...columnFilters };
    delete updated[columnKey];
    setColumnFilters(updated);
    setFilteredData(data);
  };

  const sortData = (list) => {
    if (!sort.key) return list;

    return [...list].sort((a, b) => {
      let v1 = a[sort.key];
      let v2 = b[sort.key];

      if (sort.type === "number") {
        v1 = Number(v1);
        v2 = Number(v2);
        if (isNaN(v1)) v1 = 0;
        if (isNaN(v2)) v2 = 0;

        return sort.mode === "asc" ? v1 - v2 : v2 - v1;
      } else {
        v1 = String(v1 || "");
        v2 = String(v2 || "");

        return sort.mode === "asc"
          ? v1.localeCompare(v2)
          : v2.localeCompare(v1);
      }
    });
  };

  const filteredColumns = useMemo(() => {
    return columns
      .map((col) => {
        if (col.children) {
          const filteredChildren = col.children.filter((child) =>
            selectedChildKeys.includes(child.dataIndex)
          );
          return filteredChildren.length > 0
            ? { ...col, children: filteredChildren }
            : null;
        } else {
          return selectedChildKeys.includes(col.dataIndex) ? col : null;
        }
      })
      .filter(Boolean);
  }, [columns, selectedChildKeys]);

  const handleResize =
    (dataIndex) =>
    (e, { size }) => {
      setColumnsWidth((prev) => ({
        ...prev,
        [dataIndex]: size.width,
      }));
    };

  const enhanceColumnWithPopover = (col) => {
    const isSorted = sort.key === col.dataIndex;
    const sortOrder = isSorted
      ? sort.mode === "asc"
        ? "ascend"
        : "descend"
      : null;

    const handleHeaderClick = (type) => {
      if (disabledFilter) {
        return;
      }
      let nextMode = "asc";
      if (isSorted) {
        nextMode = sort.mode === "asc" ? "desc" : "asc";
      }
      setSort({
        key: col.dataIndex,
        mode: nextMode,
        type: type || "string",
      });
      setVisiblePopover(null);
    };

    const columnWidth = columnsWidth[col.dataIndex] || col.width;

    return {
      ...col,
      width: columnWidth,
      sortOrder,
      showSorterTooltip: false,
      onHeaderCell: (column) => ({
        width: columnWidth,
        onResize: handleResize(col.dataIndex),
        onClick: () => handleHeaderClick(col.type),
        style: { cursor: "pointer" },
      }),
      title: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            cursor: "pointer",
            justifyContent: "center",
          }}
        >
          <span>{col.title}</span>
          {isSorted &&
            (sort.mode === "asc" ? (
              <CaretUpOutlined style={{ color: color || "#0080cb" }} />
            ) : (
              <CaretDownOutlined style={{ color: color || "#0080cb" }} />
            ))}
          {col.filter !== false && (
            <Popover
              onVisibleChange={(open) => {
                if (disabledFilter) {
                  return;
                }
                if (!open) {
                  const id = `cancel-filter-table-${col.dataIndex}`;
                  const ele = document.getElementById(id);
                  if (ele) {
                    ele.click();
                  }
                }
                setVisiblePopover(open ? col.dataIndex : null);
              }}
              content={
                <FilterPopover
                  setSort={setSort}
                  columnKey={col.dataIndex}
                  options={getUniqueColumnValues(col.dataIndex, col.dataIndex === lastColFilter  ? previousData :  filteredData)}
                  allOptions={getUniqueColumnValues(col.dataIndex)}
                  selected={columnFilters[col.dataIndex] || []}
                  onApply={applyFilters}
                  onClear={clearFilter}
                  onSort={sortData}
                  onClose={() => setVisiblePopover(null)}
                  type={col.type}
                  resetFilterColumn={resetFilterColumn}
                />
              }
              trigger="click"
              visible={visiblePopover === col.dataIndex}
              placement="bottom"
            >
              <FilterFilled
                onClick={(e) => e.stopPropagation()}
                style={{
                  color: color || "#0080cb",
                  cursor: "pointer",
                  opacity: currentColumnFilter.includes(col.dataIndex)
                    ? 1
                    : 0.5,
                  fontSize: 12,
                }}
              />
            </Popover>
          )}
        </div>
      ),
    };
  };

  const enhancedColumns = filteredColumns.map((col) =>
    col.children
      ? { ...col, children: col.children.map(enhanceColumnWithPopover) }
      : enhanceColumnWithPopover(col)
  );

  useEffect(() => {
    if (sort.key) applyFilters(undefined, undefined, "sort");
  }, [sort]);

  const applyFiltersAndSort = (rawData, filters, sort) => {
    let result = rawData;
    for (const [key, values] of Object.entries(filters)) {
      if (values && Array.isArray(values)) {
        if (!values.length) result = [];
        else result = result.filter((item) => values.includes(item[key]));
      }
    }

    if (sort.key) {
      result = [...result].sort((a, b) => {
        let v1 = a[sort.key];
        let v2 = b[sort.key];

        if (sort.type === "number") {
          v1 = Number(v1);
          v2 = Number(v2);
          if (isNaN(v1)) v1 = 0;
          if (isNaN(v2)) v2 = 0;

          return sort.mode === "asc" ? v1 - v2 : v2 - v1;
        } else {
          const s1 = v1 != null ? String(v1) : "";
          const s2 = v2 != null ? String(v2) : "";
          return sort.mode === "asc"
            ? s1.localeCompare(s2, "ja", { numeric: true })
            : s2.localeCompare(s1, "ja", { numeric: true });
        }
      });
    }
    setFilteredData(result);
  };

  useEffect(() => {
    if (keepFilterSort) {
      applyFiltersAndSort(data, columnFilters, sort);
    } else {
      if (Array.isArray(data) && data.length > 0) {
        const newFilters = {};
        Object.keys(data[0]).forEach((key) => {
          newFilters[key] = Array.from(new Set(data.map((item) => item[key])));
        });
        setColumnFilters(newFilters);
      }
      setFilteredData(data);
      setCurrentColumnFilter([]);
      setSort({ key: "", mode: "asc" });
    }

    const body = document.querySelector(".ant-table-body");
    if (body){
      body.scrollTop = 0;
      body.scrollLeft = 0
    }

    setLastColFilter(null)
  }, [data, keepFilterSort]);

  useEffect(() => {
    if (!show && isLeft) {
      setVisibleModal(false);
    }
  }, [isLeft, show]);

  const closePopupSelect = () => {
    setVisibleModal(false);
    dispatch(closeOverlay());
  };

  const tableRef = useRef();
  useEffect(() => {
    if (!isEmptyData(idFocus) && paging && data) {
      const index = data.findIndex((item) => item[rowKey] == idFocus);
      if (index === -1) return;
      const page = Math.floor(index / pageSize) + 1;
      setCurrentPage(page);

      setTimeout(() => {
        const body = document.querySelector(".ant-table-body");
        if (!body) return;

        const row = body.querySelector(`tr[data-row-key="${idFocus}"]`);
        if (row) {
          const rowOffsetTop = row.offsetTop;
          const rowHeight = row.offsetHeight;
          const containerScrollTop = body.scrollTop;
          const containerHeight = body.clientHeight;

          if (
            rowOffsetTop < containerScrollTop ||
            rowOffsetTop + rowHeight > containerScrollTop + containerHeight
          ) {
            body.scrollTo({ top: rowOffsetTop, behavior: "smooth" });
          }
        }
      }, 0);
    }
  }, [idFocus, data]);

  // SET CURRENT TO EXPORT
  useEffect(() => {
    if(tableKey && tableKey == "ledger"){
      dispatch(setListColumn({key:tableKey,data:selectedChildKeys}))
    }

  },[selectedChildKeys,tableKey])

  useEffect(() => {
    if(tableKey && tableKey == "ledger"){
      dispatch(setListDataTable({key:tableKey,data:filteredData}))
    }

  },[filteredData,tableKey])
  //
  const widthEle =
    tableKey && widthModalColTable[tableKey]
      ? widthModalColTable[tableKey] || 0
      : 0;
  const left =
    (widthEle - 310) / 2 + (!collapsed ? 200 : 80) + (addedLeft || 0);
  const styleModalCol =
    isLeft && tableKey
      ? {
          position: "fixed",
          left,
          top: "calc(50vh - 210px)",
        }
      : {};
  return (
    <>
      <div
        style={{
          position: "reative",
          dispalay: "flex",
          justifyContent: "space-between",
        }}
        className="countItemShowTbaleFilter mb5"
      >
        <div></div>
        <Button
          disabled={disabledFilter}
          className="buttonPC --todo-- wAuto  button--info"
          onClick={() => {
            if (isLeft) {
              dispatch(openOverlay());
            }
            setVisibleModal(true);
          }}
        >
          表示項目
        </Button>
      </div>

      <div style={{ position: "relative" }}>
        <div ref={tableRef}>
          <Table
            rowClassName={rowClassName}
            className={`gridSearch table-filter-custom-common ${className}`}
            components={{
              header: {
                // cell: ResizableHeader,
              },
              body: {
                wrapper: (props) => <tbody {...props} />,
              },
            }}
            columns={enhancedColumns}
            dataSource={filteredData}
            scroll={{ x: scrollX, y: scrollY }}
            rowKey={rowKey}
            onRow={onRow}
            pagination={
              paging
                ? {
                    ...CONFIG.paging,
                    pageSize,

                    current: Number(currentPage) || 1,
                    onChange: (curr) => {
                      if (disabledFilter) {
                        return;
                      }
                      setCurrentPage(curr);
                    },
                    showTotal: (total, range) =>
                      `${range[0]} ～ ${range[1]} / ${total} 件 表示`,
                  }
                : false
            }
            onChange={(pagination, filters, sorter) => {
              if (sorter && sorter.field && sorter.order) {
                setSort({
                  key: sorter.field,
                  mode: sorter.order === "ascend" ? "asc" : "desc",
                });
              } else {
                setSort({ key: "", mode: "asc" });
              }
            }}
          />
        </div>
        {visibleModal && isLeft && (
          <div style={styleModalCol} className="popup-select-table-custom">
            <div className="popup-select-header ">
              <div className="bold popup-select-title">表示項目選択</div>
              <CloseOutlined
                onClick={closePopupSelect}
                style={{ fontSize: 16, cursor: "pointer" }}
              />
            </div>

            <div
              className="popup-select-body"
              style={{ height: 280, overflowY: "auto", marginBottom: 16 }}
            >
              <div style={{ marginBottom: 8 }}>
                <Checkbox
                  indeterminate={isIndeterminate}
                  checked={isAllSelected}
                  onChange={handleSelectAllChange}
                >
                  <span className="bold">すべて選択</span>
                </Checkbox>
              </div>

              <Checkbox.Group
                style={{ display: "flex", flexDirection: "column", gap: 8 }}
                value={selectedChildKeys}
                onChange={setSelectedChildKeys}
              >
                {allChildColumns.map((child) => (
                  <Checkbox
                    style={{ marginLeft: 20 }}
                    key={child.dataIndex}
                    value={child.dataIndex}
                  >
                    {child.title}
                  </Checkbox>
                ))}
              </Checkbox.Group>
            </div>

            <div className="popup-select-footer" style={{ textAlign: "right" }}>
              <Button
                className="buttonPC button--outline --todo-- wAuto"
                onClick={closePopupSelect}
              >
                <CloseCircleOutlined />
                {lang.CLOSE}
              </Button>
            </div>
          </div>
        )}
      </div>

      {!isLeft && (
        <Modal
          centered={true}
          visible={visibleModal}
          width={310}
          title="表示項目選択"
          onCancel={() => setVisibleModal(false)}
          onOk={() => setVisibleModal(false)}
          footer={
            <Button
              key={3}
              className="buttonPC button--outline --todo-- wAuto"
              onClick={() => setVisibleModal(false)}
            >
              <CloseCircleOutlined />
              {lang.CLOSE}
            </Button>
          }
        >
          <div style={{ height: 280, overflowY: "auto" }}>
            <div style={{ marginBottom: 8 }}>
              <Checkbox
                indeterminate={isIndeterminate}
                checked={isAllSelected}
                onChange={handleSelectAllChange}
              >
                <span className="bold"> すべて選択</span>
              </Checkbox>
            </div>
            <Checkbox.Group
              style={{ display: "flex", flexDirection: "column", gap: 8 }}
              value={selectedChildKeys}
              onChange={setSelectedChildKeys}
            >
              {allChildColumns.map((child) => (
                <Checkbox
                  style={{ marginLeft: 20 }}
                  key={child.dataIndex}
                  value={child.dataIndex}
                >
                  {child.title}
                </Checkbox>
              ))}
            </Checkbox.Group>
          </div>
        </Modal>
      )}
    </>
  );
};

export default React.memo(CommonFilterTable);
